import React from 'react';
import { WORKSPACE_CSS, WS } from './workspaceData.ts';
import WorkspaceTopBar from './WorkspaceTopBar.tsx';

interface WorkspaceLayoutProps {
  // TopBar props
  isNew: boolean;
  name: string;
  icon: string;
  setIcon: (v: string) => void;
  prefill?: any;
  enabled: boolean;
  saving: boolean;
  saved: boolean;
  onSave: () => void;
  onBack: () => void;
  canSave?: boolean;

  // 3-column children
  leftPanel: React.ReactNode;
  centerPanel: React.ReactNode;
  rightPanel: React.ReactNode;
  // Collapses the left (Skill Library) column down to a narrow rail.
  leftCollapsed?: boolean;
}

export default function WorkspaceLayout({
  isNew, name, icon, setIcon,
  prefill, enabled, saving, saved, onSave, onBack,
  canSave,
  leftPanel, centerPanel, rightPanel,
  leftCollapsed,
}: WorkspaceLayoutProps) {
  return (
    <div className="ws-layout-root" style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: WS.bg,
      fontFamily: "'Manrope', system-ui, sans-serif",
      overflow: 'hidden',
      color: WS.ink,
    }}>
      <style>{WORKSPACE_CSS}</style>

      {/* Top bar */}
      <WorkspaceTopBar
        isNew={isNew}
        name={name}
        icon={icon}
        setIcon={setIcon}
        prefill={prefill}
        enabled={enabled}
        saving={saving}
        saved={saved}
        canSave={canSave}
        onSave={onSave}
        onBack={onBack}
      />

      {/* 3-column body */}
      <div
        className="ws-layout-body"
        style={{ flex: 1, ['--ws-left-width' as any]: leftCollapsed ? '52px' : '260px' }}
      >
        {/* LEFT */}
        <div className="ws-layout-pane ws-layout-pane-left" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {leftPanel}
        </div>

        {/* CENTER */}
        <div className="ws-layout-pane ws-layout-pane-center" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {centerPanel}
        </div>

        {/* RIGHT */}
        <div className="ws-layout-pane ws-layout-pane-right" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {rightPanel}
        </div>
      </div>
    </div>
  );
}
